<section class="w-full">
    @if(view.site) {
    <div class="w-full relative overflow-hidden lg:h-[400px] md:h-[300px] h-[140px] border-b-4 border-primary-500 bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center"
        [ngStyle]="{ 'background-image': 'url(' + view.imageHref + ')' }">
        <!-- <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div> -->
        <!-- <h1 class="z-10 custom_font text-6xl text-white text-shadow">{{view.page?.content.name}}</h1> -->
        <!-- <p class="z-10 text-xl text-white font-semibold"><span class="text-emerald-500 font-semibold">Home</span> / About</p> -->
    </div>
    }
    <div class="w-full bg-gray-100" id="about">
        <div class="mx-auto sm:px-6 pt-8 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8 lg:gap-y-16">
            <div class="p-4 mg:p-10 lg:p-10 rounded-3xl">
                <div class="flex flex-col">
                    @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                    @case (1) {
                    <app-heading_section-type01
                        [options]="{heading:view.page?.content.name,title:'Experience your new Adventure with Us',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                    }
                    @case (2) {
                    <app-heading_section-type01
                        [options]="{heading:view.page?.content.name,title:'Experience your new Adventure with Us',image:'assets/xltravel/swoosh-01.svg', description:''}"></app-heading_section-type01>
                    }
                    }
                    }
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-25 mt-4 mb-10">
                    <div class="flex flex-col md:flex-row lg:flex-row">
                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'airplanemode_active'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Air Travel</h3>
                            <p class="">Domestic and International Reservations</p>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row lg:flex-row">
                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'mat_solid:car_rental'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Car Rental</h3>
                            <p class="">Domestic and International Reservations</p>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row lg:flex-row">

                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Hotel reservations</h3>
                            <p class="">Including family deals, early booking discounts</p>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row lg:flex-row">

                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'feather:compass'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Travel Packages</h3>
                            <p class="">Including family deals, early booking discounts</p>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row lg:flex-row">

                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Transfer & Chauffeur</h3>
                            <p class="">Parking, lounge, cruises, tour reservations</p>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row lg:flex-row">

                        <mat-icon
                            class="icon-size-16 p-3 ring-2 ring-primary-500  text-primary-500 hover:bg-primary-500 transition transition-duration: 500ms hover:text-white mt-2"
                            [svgIcon]="'heroicons_mini:identification'"></mat-icon>
                        <div class="flex flex-col md:ml-3 lg:ml-3">
                            <h3 class="text-xl font-semibold custom_font">Visa & Health Advice</h3>
                            <p class="">Guidance on visa processes & health recommendations</p>
                        </div>
                    </div>

                </div>
                <div class="flex flex-row justify-center">
                    <a [routerLink]="'/contact-us'"
                        class="bg-primary dark:bg-slate-900 text-white ring-primary-500 font-bold py-2 px-6 transition transition-duration: 500ms hover:bg-primary-100 hover:text-primary dark:hover:bg-accent-500 cursor-pointer inline-block text-center no-underline">Contact Us</a>
                </div>
            </div>
            <div>
                <p class="p-4 mg:p-10 lg:p-10 text-justify" [innerHTML]="view.page?.content.rawContent"></p>
            </div>
        </div>

    </div>
    @if(view.site?.id === 63) {
        <div class="w-full flex flex-col mt-10">
            <div class="flex flex-col justify-center items-center">
                <!-- <div class="flex items-baseline">
                    <span class="w-10 border-b-2 border-primary-500"></span>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                    <h6 class="uppercase font-semibold tracking-widest text-lg text-primary-500 ml-3 mr-3">Travel Experts</h6>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                    <span class="w-2 ml-1 border-b-2 border-primary-500"></span>
                    <span class="w-10 border-b-2 border-primary-500"></span>
                    
                </div>
                <h1 class=" mt-3 text-6xl font-semibold custom_font tracking-wide">Get to know Our Expert Guides</h1> -->
                @if (view.site && view.site.profile && view.site.profile.heading) {
                @switch (view.site.profile.heading.position) {
                @case (1) {
                <app-heading_section-type01
                    [options]="{heading:'Travel Experts',title:'Get to know Our Expert Guides',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                }
                @case (2) {
                <app-heading_section-type01
                    [options]="{heading:'Travel Experts',title:'Get to know Our Expert Guides',image:'assets/xltravel/swoosh-01.svg', description:''}"></app-heading_section-type01>
                }
                }
                }
            </div>
            <div class="w-[90%] m-auto mb-16 mt-10">
                <div class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    @for(member of view.teamMembers; track member) {
                    <fuse-card class="w-full flex flex-col text-center">
                            <div class="flex flex-col justify-center bg-white rounded-lg shadow-md text-center">
                            <img src="{{member.image}}" alt="Member Profile" class="w-50 h-50 rounded-full mb-4 p-4 mx-auto">
                                <h3 class="text-xl font-semibold mb-2 mt-2">{{member.name}}</h3>
                                <p class="text-primary-500">{{member.company}}</p>
                                <div class="flex justify-center items-center my-4">
                                    <button (click)="openModal(member)" class="bg-white dark:bg-slate-900 ring-primary-500 font-bold py-1 px-4 transition transition-duration: 500ms hover:bg-primary-500 hover:text-white dark:hover:bg-accent-500">View</button>
                                </div>
                            </div>
                    </fuse-card>
                    }
                </div>
            </div>
        </div>
    }
</section>